import UserStorage from "../libs/cache/UserStorage"

export default class PortPref extends UserStorage<any> {
    static _i:PortPref
    static get i(){
        if (!this._i) this._i = new PortPref("upref")
        return this._i
    }
}